// UI labels for the blog index and post pages.

import type { Locale } from './theme';

export type BlogStrings = {
  indexTitle: string;
  indexLead: string;
  eyebrow: string;
  readingTime: string;
  publishedOn: string;
  updatedOn: string;
  by: string;
  backToIndex: string;
  more: string;
  empty: string;
  latestLabel: string;
  allPostsLabel: string;
  searchLabel: string;
  searchPlaceholder: string;
  resultsLabel: (count: number) => string;
  noResults: string;
  ctaTitle: string;
  ctaSub: string;
  ctaButton: string;
  metaIndexTitle: string;
  metaIndexDescription: string;
  shareLabel: string;
  rssLabel: string;
};

const STRINGS: Record<Locale, BlogStrings> = {
  pt: {
    indexTitle: 'Histórias, guias e estratégias',
    indexLead:
      'O que aprendemos a construir presença digital para PMEs portuguesas. Práticas concretas, sem teoria desnecessária.',
    eyebrow: 'Blog',
    readingTime: 'min de leitura',
    publishedOn: 'Publicado a',
    updatedOn: 'Atualizado a',
    by: 'por',
    backToIndex: 'Voltar ao blog',
    more: 'Continuar a ler →',
    empty: 'Em breve. A escrever a primeira história.',
    latestLabel: 'Novo no blog',
    allPostsLabel: 'Todos os posts',
    searchLabel: 'Pesquisar',
    searchPlaceholder: 'Pesquisar por tema, titulo ou tag...',
    resultsLabel: (count) => `${count} resultado${count === 1 ? '' : 's'}`,
    noResults: 'Sem posts para esta pesquisa.',
    ctaTitle: 'Pronto para começar o teu projeto?',
    ctaSub: 'Em 20 minutos percebemos o que precisas e damos-te um preço.',
    ctaButton: 'Pedir orçamento',
    metaIndexTitle: 'Blog · Locusly',
    metaIndexDescription:
      'Guias, estratégias e histórias sobre transformação digital, SEO local e construção de presença online para PMEs portuguesas.',
    shareLabel: 'Partilhar',
    rssLabel: 'RSS',
  },
  en: {
    indexTitle: 'Stories, playbooks, and strategy',
    indexLead:
      'What we have learned building digital presence for Portuguese small and medium businesses. Concrete practices, no fluff.',
    eyebrow: 'Blog',
    readingTime: 'min read',
    publishedOn: 'Published',
    updatedOn: 'Updated',
    by: 'by',
    backToIndex: 'Back to blog',
    more: 'Keep reading →',
    empty: 'Coming soon. First story being written.',
    latestLabel: 'New on the blog',
    allPostsLabel: 'All posts',
    searchLabel: 'Search',
    searchPlaceholder: 'Search by topic, title, or tag...',
    resultsLabel: (count) => `${count} result${count === 1 ? '' : 's'}`,
    noResults: 'No posts match this search.',
    ctaTitle: 'Ready to start your project?',
    ctaSub: 'A 20-minute call is enough to scope your build and quote it.',
    ctaButton: 'Request a quote',
    metaIndexTitle: 'Blog · Locusly',
    metaIndexDescription:
      'Guides, playbooks, and stories on digital transformation, local SEO, and building an online presence for small and medium businesses.',
    shareLabel: 'Share',
    rssLabel: 'RSS',
  },
};

export function getBlogStrings(locale: Locale): BlogStrings {
  return STRINGS[locale];
}

export function formatPostDate(iso: string, locale: Locale): string {
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString(locale === 'pt' ? 'pt-PT' : 'en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
